(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kanga-social-proof"] && !Shopify.designMode) return;
  try {
    
  /**
   * Click-to-play for creator cards. Delegated, so it covers cards added by
   * the theme editor without rebinding. Pausing others keeps only one video
   * playing at a time.
   */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-kanga-play]');
    if (!button) return;

    const media = button.closest('.kanga-social-card__media');
    const video = media?.querySelector('video');
    if (!video) return;

    document.querySelectorAll('.kanga-social-card__media[data-playing]').forEach((other) => {
      if (other === media) return;
      other.querySelector('video')?.pause();
      delete other.dataset.playing;
    });

    media.dataset.playing = 'true';
    video.play();
  });

  document.addEventListener(
    'pause',
    (event) => {
      if (!(event.target instanceof HTMLVideoElement)) return;
      const media = event.target.closest('.kanga-social-card__media');
      if (media) delete media.dataset.playing;
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
